export default "__VITE_ASSET__emgbuQ9o__"